import { ApproveModalDirective } from './approve.directive';

export const Directives = [
	ApproveModalDirective,
];
